import axios from "./axios-auth";

const getPaymentLink = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getpaymentlink",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getPaymentLink api err", err);
      });
  });

const processPayment = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/processpayment",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp.data);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("processPayment api err", err);
      });
  });

export { getPaymentLink, processPayment };
